module.exports = __webpack_public_path__ + "93405743349371e59ecfdad24ca54e03.mp3";


//////////////////
// WEBPACK FOOTER
// ../lib/assets/shared/verder_spelen.mp3
// module id = 92
// module chunks = 0